var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    { attrs: { page: "/reports", pageTitle: "Reports" } },
    [
      _c(
        "v-container",
        { staticClass: "pt-0", attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            [
              _vm.can("View admin reports")
                ? _c(
                    "v-col",
                    { attrs: { cols: "12", xs: "12", sm: "4", lg: "3" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "soli-round" },
                        [
                          _c(
                            "Link",
                            { attrs: { href: "/reports/weekly-recap" } },
                            [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-list",
                                    { staticClass: "soli-grey" },
                                    [
                                      _c("v-card-title", [
                                        _vm._v("Weekly Studio Recap"),
                                      ]),
                                      _vm._v(" "),
                                      _c("v-card-subtitle", [
                                        _vm._v(
                                          "Trailing week KPIs by\n                                    location"
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.can("View financial reports")
                ? _c(
                    "v-col",
                    { attrs: { cols: "12", xs: "12", sm: "4", lg: "3" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "soli-round" },
                        [
                          _c(
                            "Link",
                            { attrs: { href: "/reports/teacher-pay" } },
                            [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-list",
                                    { staticClass: "soli-grey" },
                                    [
                                      _c("v-card-title", [
                                        _vm._v("Teacher Pay"),
                                      ]),
                                      _vm._v(" "),
                                      _c("v-card-subtitle", [
                                        _vm._v(
                                          "Monthly pay due to\n                                    teachers"
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.can("View financial reports")
                ? _c(
                    "v-col",
                    { attrs: { cols: "12", xs: "12", sm: "4", lg: "3" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "soli-round" },
                        [
                          _c(
                            "Link",
                            { attrs: { href: "/reports/upcoming-invoices" } },
                            [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-list",
                                    { staticClass: "soli-grey" },
                                    [
                                      _c("v-card-title", [
                                        _vm._v("Upcoming Invoices"),
                                      ]),
                                      _vm._v(" "),
                                      _c("v-card-subtitle", [
                                        _vm._v(
                                          "Preview customer\n                                    charges"
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.can("View generic reports")
                ? _c(
                    "v-col",
                    { attrs: { cols: "12", xs: "12", sm: "4", lg: "3" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "soli-round" },
                        [
                          _c(
                            "Link",
                            { attrs: { href: "/reports/past-due-invoices" } },
                            [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-list",
                                    { staticClass: "soli-grey" },
                                    [
                                      _c("v-card-title", [
                                        _vm._v("Past Due Invoices"),
                                      ]),
                                      _vm._v(" "),
                                      _c("v-card-subtitle", [
                                        _vm._v("Review unpaid charges"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.can("View statistical reports")
                ? _c(
                    "v-col",
                    { attrs: { cols: "12", xs: "12", sm: "4", lg: "3" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "soli-round" },
                        [
                          _c(
                            "Link",
                            { attrs: { href: "/reports/first-visits" } },
                            [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-list",
                                    { staticClass: "soli-grey" },
                                    [
                                      _c("v-card-title", [
                                        _vm._v("First Visits"),
                                      ]),
                                      _vm._v(" "),
                                      _c("v-card-subtitle", [
                                        _vm._v(
                                          "View student's first time visiting a\n                                    class or private lesson series\n                                    (Assessments...)\n                                "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.can("View statistical reports")
                ? _c(
                    "v-col",
                    { attrs: { cols: "12", xs: "12", sm: "4", lg: "3" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "soli-round" },
                        [
                          _c(
                            "Link",
                            { attrs: { href: "/reports/enrollments" } },
                            [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-list",
                                    { staticClass: "soli-grey" },
                                    [
                                      _c("v-card-title", [
                                        _vm._v("Enrollments"),
                                      ]),
                                      _vm._v(" "),
                                      _c("v-card-subtitle", [
                                        _vm._v("View memberships sold"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.can("View statistical reports")
                ? _c(
                    "v-col",
                    { attrs: { cols: "12", xs: "12", sm: "4", lg: "3" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "soli-round" },
                        [
                          _c(
                            "Link",
                            { attrs: { href: "/reports/drop-ins" } },
                            [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-list",
                                    { staticClass: "soli-grey" },
                                    [
                                      _c("v-card-title", [_vm._v("Drop-Ins")]),
                                      _vm._v(" "),
                                      _c("v-card-subtitle", [
                                        _vm._v(
                                          "View Drop-in passes\n                                    sold"
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.can("View statistical reports")
                ? _c(
                    "v-col",
                    { attrs: { cols: "12", xs: "12", sm: "4", lg: "3" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "soli-round" },
                        [
                          _c(
                            "Link",
                            { attrs: { href: "/reports/withdrawals" } },
                            [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-list",
                                    { staticClass: "soli-grey" },
                                    [
                                      _c("v-card-title", [
                                        _vm._v("Withdrawals"),
                                      ]),
                                      _vm._v(" "),
                                      _c("v-card-subtitle", [
                                        _vm._v(
                                          "View Membership\n                                    cancellations"
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.can("View admin reports")
                ? _c(
                    "v-col",
                    { attrs: { cols: "12", xs: "12", sm: "4", lg: "3" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "soli-round" },
                        [
                          _c(
                            "Link",
                            { attrs: { href: "/reports/gift-cards" } },
                            [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-list",
                                    { staticClass: "soli-grey" },
                                    [
                                      _c("v-card-title", [
                                        _vm._v("Gift Cards"),
                                      ]),
                                      _vm._v(" "),
                                      _c("v-card-subtitle", [
                                        _vm._v(
                                          "Review gift card\n                                    purchases"
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.can("View financial reports")
                ? _c(
                    "v-col",
                    { attrs: { cols: "12", xs: "12", sm: "4", lg: "3" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "soli-round" },
                        [
                          _c(
                            "Link",
                            { attrs: { href: "/reports/finance-entry" } },
                            [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-list",
                                    { staticClass: "soli-grey" },
                                    [
                                      _c("v-card-title", [
                                        _vm._v("Finance Entry"),
                                      ]),
                                      _vm._v(" "),
                                      _c("v-card-subtitle", [
                                        _vm._v(
                                          "Record Quickbooks monthly finances\n                                "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }